import Vuex from 'vuex'

export default new Vuex.Store({
  state: {
    accountInfo: null,
  },
  mutations: {
    setAccountInfo: (state, accountInfo) => state.accountInfo = accountInfo,
  }
})